import React from 'react';
import classNames from 'classnames';
/**
 * Bronson Main component.
 * @see https://bronson.vwfs.io/default/docs/objects/main-layout-containers.html
 * @constructor
 */
export function Main({ children, ...otherProps }) {
    const mainClassName = classNames('o-main').trim();
    return (React.createElement("main", { className: mainClassName, ...otherProps }, children));
}
